import R from 'ramda';

export const getProductDropdownOptions = ({ products }) =>
  R.map(
    (product) => ({
      key: R.prop('slug', product),
      value: R.prop('title', product),
      additionalText: `${R.length(R.prop('variants', product))} Shades`,
    }),
    products
  );

export const getSelectedProduct = ({ products, actualProductSlug }) =>
  R.find(R.propEq('slug', actualProductSlug), products);

export const onModalOpen = () => {
  if (window) {
    window.document.documentElement.style.overflow = 'hidden';
    window.document.documentElement.style.position = 'fixed';
  }
};

export const onModalClose = () => {
  if (window) {
    window.document.documentElement.style.overflow = 'initial';
    window.document.documentElement.style.position = 'initial';
  }
};

const mapVariantsToSwatch = ({ variants }) =>
  Array.isArray(variants)
    ? R.map(
        ({ uid, sku, name, colour, ingredients, texture, url }) => ({
          uid,
          sku,
          itemName: name,
          ...(colour && { skuColor: `#${colour}` }),
          ingredients,
          skuImage: texture,
          url,
        }),
        variants
      )
    : [];

export const getProductSwatches = ({ product }) =>
  mapVariantsToSwatch({ variants: R.prop('variants')(product) });

export const filterExcludedVariantsFromProducts = ({
  filteredProducts,
  excludedProductsVariantsSkus,
}) =>
  R.map(
    (product) => ({
      ...product,
      variants: R.filter(
        (variant) =>
          !R.includes(R.prop('sku', variant), excludedProductsVariantsSkus),
        R.prop('variants', product)
      ),
    }),
    filteredProducts
  );

export const buildResultLink = ({ selectedProduct, selectedProductSwatch }) =>
  `${R.prop('productUrl', selectedProduct)}?shade=${encodeURIComponent(
    R.prop('itemName', selectedProductSwatch)
  )}#buy-now`;

export const getSelectedMultiColorProduct = ({ products, selectedProduct }) =>
  R.find(
    (product) => R.eqProps('pc_products_api_id', product, selectedProduct),
    products
  );

export const getSelectedMultiColorSwatch = ({
  vtoActualProductSku,
  swatches,
  selectedMultiColorSwatches,
  allMultiColorVariants,
}) =>
  R.find(R.propEq('sku', vtoActualProductSku), swatches) ||
  R.find(R.propEq('sku', vtoActualProductSku), selectedMultiColorSwatches) ||
  R.find(R.propEq('sku', vtoActualProductSku), allMultiColorVariants);

export const getMultiColorShadeNames = ({ shades }) =>
  Array.isArray(shades) && shades.length > 0
    ? R.join(
        ', ',
        R.map((shade) => shade.name, shades)
      )
    : '';

export const getMultiColorSwatches = ({ product }) => {
  const variants = R.propOr([], 'variants', product);

  return Array.isArray(variants)
    ? R.map(
        // eslint-disable-next-line camelcase
        ({ guid, colour, images, shade_list }) => ({
          guid,
          sku: guid,
          itemName: getMultiColorShadeNames({ shades: shade_list }),
          shadeList: shade_list,
          ...(colour && { skuColor: `#${colour}` }),
          skuImage: R.pathOr('', [0, 'url'], images),
          isMulti: true,
        }),
        variants
      )
    : [];
};

export const getAllMultiColorVariants = ({ products }) =>
  R.map((product) => R.prop('variants', product), products).flat();

export const checkIfMultiColorEnabled = ({
  vto,
  correspondingMultiColorProduct,
}) =>
  Boolean(R.prop('isMultiColorEnabled', vto) && correspondingMultiColorProduct);

export const selectYMKMethod = ({ selectedProductSwatch }) =>
  R.prop('isMulti', selectedProductSwatch)
    ? YMK.applyMakeupByLook
    : YMK.applyMakeupBySku;

export const getVtoControlsHeight = ({
  isDesktopVtoVersion,
  generateMultiColorControls,
}) => {
  if (generateMultiColorControls) {
    return isDesktopVtoVersion ? 215 : 225;
  }
  return 200;
};

export const base64ToBlob = (base64String, contentType = 'image/png') => {
  const byteCharacters = atob(
    base64String.replace(/^data:image\/\w+;base64,/, '')
  );
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};
